import React, { useEffect, useState, useRef } from 'react';
import {
  Button,
  Table,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { saveAs } from "file-saver";
import nxtIcn from "./assets/next-button.png";
import preIcn from "./assets/previous-button.png";
import playIcn from "./assets/play-button.png";
import vwAllIcn from "./assets/view-all-button.png";
import homBtn from "./assets/button-home-filled-outline.png";
import dldIcn from "./assets/download-icon.png";
import lkIcnBlk from "./assets/link-icon-blk.png";
import lkIcn from "./assets/link-icon.png";
import videojs from "video.js";
import "videojs-playlist";
import "videojs-contrib-ads";
import "videojs-ima";
import "video.js/dist/video-js.css";
import "videojs-ima/dist/videojs.ima.css";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
import { getSingleVideo } from "./service/featured";
import { getBookmarks } from "./service/auth";
import useVideoAnalytics from "./hooks/useVideoAnalytics";
import { copyToClipboard, getVideoMimeType } from "./helpers/globals";
import { CopyEmbedVideo } from './EmbedVideo';
import { Link } from 'react-router-dom';
import Hls from 'hls.js/dist/hls.js';
import { useAuth } from './components/AuthProvider';
import Header from './components/Header';
import Footer from './components/Footer';
import VideoOverlayMenu from './components/VideoOverlayMenu';
import { extractVideoId, generateVideoSlug } from "./utils/urlHelpers";

const SingleVideo = () => {
  const videoRef = useRef(null);
  const [video, setVideo] = useState(null);
  const [curTitle, setCurTitle] = useState("");
  const [curArtist, setcurArtist] = useState("");
  const [singleThnail, setSingleThnail] = useState("");
  const [linkOut, setLink] = useState("");
  const [albumArt, setAlbumArt] = useState("");
  const [orlFile, setOrlFile] = useState("");
  const [isShare, setIsShare] = useState(false);
  const [isVideoFnd, setIsVideoFnd] = useState(true);
  const [modal, setModal] = useState(false);
  const [copiedTitle, setCopiedTitle] = useState("");
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [videoProgress, setVideoProgress] = useState(0);
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [isAdPlaying, setIsAdPlaying] = useState(false);
  const [showSkipOverlay, setShowSkipOverlay] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const overlayTimerRef = useRef(null);
  const mouseMoveTimerRef = useRef(null);

  const analytics = useVideoAnalytics();
  const { preventGuestAccess, toggleAuthFlow } = useAuth();



  const toggle = () => setModal(!modal);

  const changeTitle = (title) => {
    setModal(!modal);
    setCopiedTitle(title);
  };

  // Video overlay handlers
  const handleVideoMouseEnter = () => {
    if (window.screen.width > 800 && !isFullscreen) {
      setShowSkipOverlay(true);
    }
  };

  const handleVideoMouseLeave = () => {
    if (window.screen.width > 800 && isVideoPlaying && !isFullscreen) {
      setShowSkipOverlay(false);
    }
  };

  const handleMouseMove = () => {
    if (isFullscreen) {
      setShowSkipOverlay(true);
      // Clear existing timer
      if (mouseMoveTimerRef.current) {
        clearTimeout(mouseMoveTimerRef.current);
      }
      // Auto-hide after 2 seconds of no mouse movement
      mouseMoveTimerRef.current = setTimeout(() => {
        if (isFullscreen) {
          setShowSkipOverlay(false);
        }
      }, 2000);
    }
  };

  const handleVideoTap = (e) => {
    // Only show overlay if clicking on video element, not controls
    if (window.screen.width <= 800 &&
      (e.target.tagName === 'VIDEO' || e.target.classList.contains('video-skip-overlay'))) {
      setShowSkipOverlay(true);
      // Auto-hide after 2 seconds on mobile
      if (overlayTimerRef.current) {
        clearTimeout(overlayTimerRef.current);
      }
      overlayTimerRef.current = setTimeout(() => {
        setShowSkipOverlay(false);
      }, 2000);
    }
  };

  const handlePausePlay = (e) => {
    e.stopPropagation();
    if (player.current) {
      if (player.current.paused()) {
        player.current.play();
      } else {
        player.current.pause();
      }
    }
  };

  const handleFullscreen = (e) => {
    e.stopPropagation();
    if (player.current) {
      if (player.current.isFullscreen()) {
        player.current.exitFullscreen();
      } else {
        player.current.requestFullscreen();
      }
    }
  };

  const player = useRef(null);

  let IsNoVideo = ({ children }) => {
    return !isVideoFnd ? children : <></>;
  };

  const changeVideo = (id, e) => {
    const record = video
    analytics.record();
    player.current.play();

    record.is_playing = true;
    setVideo(record);
  };

  const showThumbnail = (id) => {
    const img = document.getElementById(`hoverimg${id}`);
    img.style.marginTop = 25 + "px";
    img.style.visibility = "visible";
  };

  const hideThumbnail = (id) => {
    const img = document.getElementById(`hoverimg${id}`);
    img.style.visibility = "hidden";
  };

  const downloadOriginal = () => {
    const arr = orlFile.split(".");
    saveAs(orlFile,
      `${curTitle.replaceAll(" ", "_")}.${arr[arr.length - 1]}`);
  };

  // Detect mobile device on client-side
  useEffect(() => {
    setIsMobile(window.screen.width <= 800);
  }, []);

  useEffect(() => {
    let imaOptions = {
      adTagUrl:
        "https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/22978710279/jp-test-1&ciu_szs=300x250&env=vp&impl=s&gdfp_req=1&output=vast&unviewed_position_start=1&url=[referrer_url]&description_url=[description_url]&correlator=[timestamp]",
      // disableCustomPlaybackForIOS10Plus: true,
    };
    const uuid = extractVideoId(window.location.pathname);

    if (uuid) {
      imaOptions.adTagUrl =
        "https://pubads.g.doubleclick.net/gampad/ads?iu=/22978710279/halfpage-for-video&description_url=[placeholder]&tfcd=0&npa=0&sz=640x480&ciu_szs=300x600&gdfp_req=1&output=vast&env=vp&unviewed_position_start=1&impl=s&correlator=";
      getSingleVideo(uuid)
        .then((res) => {
          setVideo(res.data.data);
          let record = res.data.data;
          toggleAuthFlow(record?.is_premium === true);

          // Update URL bar to SEO-friendly slug if not already formatted
          if (record?.artist && record?.title && record.id) {
            const videoId = record.id;
            const canonicalSlug = generateVideoSlug(record.artist, record.title, videoId);
            const expectedPath = `/video/${canonicalSlug}`;
            if (window.location.pathname !== expectedPath) {
              window.history.replaceState(null, "", expectedPath + window.location.search);
            }
          }

          setcurArtist(record.artist);
          setCurTitle(record.title);
          setSingleThnail(record.thumbnail_url);
          setLink(record.link_out);
          setAlbumArt(record.album_artwork);
          setIsShare(record.is_shareable);
          setOrlFile(record.original_file);
          const url = { src: record.video_url, type: getVideoMimeType(record.video_url) };

          const videoOp = {
            controls: false,
          };
          player.current = videojs(videoRef.current, videoOp);
          const Button = videojs.getComponent("Button");
          const preBtn = new Button(player.current, {});
          preBtn.controlText("Previous");
          preBtn.addClass("vjs-visible-text");

          const preBtnDom = preBtn.el();
          preBtnDom.id = 'previous-btn';
          preBtnDom.innerHTML = `<img id='previous-btn-img' src=${preIcn} width="25%" />`;
          preBtnDom.onclick = function (e) {
            if (!player.current.el().classList.contains('vjs-waiting')) {
              player.current.playlist?.previous?.();
            }
          };
          player.current.getChild("ControlBar").addChild(preBtn, {}, 1);

          const nextBtn = new Button(player.current, {});
          nextBtn.controlText("Next");
          nextBtn.addClass("vjs-visible-text");

          const nextBtnDom = nextBtn.el();
          nextBtnDom.id = 'next-btn';
          nextBtnDom.innerHTML = `<img id='next-btn-img' src=${nxtIcn} width="25%" />`;
          nextBtnDom.onclick = function (e) {
            if (!player.current.el().classList.contains('vjs-waiting')) {
              player.current.playlist?.next?.();
            }
          };
          player.current.getChild("ControlBar").addChild(nextBtn, {}, 2);
          // player.current.playlist(urls);
          // player.current.playlist.autoadvance(0);
          player.current.src(url)
          player.current.on("play", () => {
            preventGuestAccess();
            setIsVideoPlaying(true);
            setShowSkipOverlay(false);
            analytics.start(record.id);
            setCurTitle(record.title);
            setcurArtist(record.artist);
            record.is_playing = true;
          });

          player.current.on("ended", () => {
            setIsVideoPlaying(false);
            setShowSkipOverlay(false);
            analytics.record();
          });
          player.current.ima(imaOptions);

          // Listen for ad events to hide overlay during ads
          player.current.on("ads-ad-started", () => {
            setIsAdPlaying(true);
          });

          player.current.on("ads-ad-ended", () => {
            setIsAdPlaying(false);
          });

          // player.current.ima.initializeAdDisplayContainer();
          // player.current.ima.requestAds();

          // let firInd = videos[0].video_url.lastIndexOf("/");
          // let ltInd = videos[0].video_url.lastIndexOf(".")
          player.current.on("pause", () => {
            setIsVideoPlaying(false);
            if (window.screen.width > 800) {
              setShowSkipOverlay(true);
            }
            analytics.pause();
          });

          player.current.on("timeupdate", () => {
            const currentTime = player.current.currentTime();
            const duration = player.current.duration();
            if (duration > 0) {
              setVideoProgress((currentTime / duration) * 100);
            }
          });

          player.current.on("touchstart", (e) => {
            if (e.target.classList.contains("vjs-playing")) {
              // this.bigPlayButton.show();
              analytics.pause();
              player.current.pause();
            } else {
              player.current.play();
            }
            if (e.target.id === 'next-btn' || e.target.id === 'next-btn-img') {
              document.getElementById('next-btn')?.click?.();
            } else if (e.target.id === 'previous-btn' || e.target.id === 'previous-btn-img') {
              document.getElementById('previous-btn')?.click?.();
            }
          });
          return () => {
            player.current.dispose();
          };
        })
        .catch((e) => {
          setIsVideoFnd(false);
          setVideo([]);
          console.log(e);
        });
    }
  }, [preventGuestAccess]);

  // Fetch bookmark status for current video
  useEffect(() => {
    const checkBookmarkStatus = async () => {
      const authToken = localStorage.getItem("authToken");
      if (!authToken || !video?.id) return;

      try {
        const response = await getBookmarks();
        const bookmarks = response.data?.data?.bookmarks || [];
        const isVideoBookmarked = bookmarks.some(b => b.id === video.id);
        setIsBookmarked(isVideoBookmarked);
      } catch (error) {
        console.error("Failed to fetch bookmarks:", error);
      }
    };

    checkBookmarkStatus();
  }, [video?.id]);

  // Spacebar pause/play handler
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.code === 'Space' && e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') {
        e.preventDefault();
        handlePausePlay(e);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  // Fullscreen change handler
  useEffect(() => {
    const handleFullscreenChange = () => {
      const isCurrentlyFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );
      setIsFullscreen(isCurrentlyFullscreen);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, []);

  // Global mouse move handler for fullscreen mode
  useEffect(() => {
    if (isFullscreen) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('click', handleVideoTap);

      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('click', handleVideoTap);
      };
    }
  }, [isFullscreen]);

  // Load / Refresh Revive Adserver script
  useEffect(() => {
    const REVIVE_ID = "727bec5e09208690b050ccfc6a45d384";
    const triggerRevive = () => {
      if (window.reviveAsync && window.reviveAsync[REVIVE_ID]) {
        try {
          window.reviveAsync[REVIVE_ID].refresh();
        } catch (e) {
          console.error("Error refreshing Revive ads:", e);
        }
      }
    };

    if (!document.getElementById("revive-async-script")) {
      const script = document.createElement("script");
      script.id = "revive-async-script";
      script.src = "//servedby.revive-adserver.net/asyncjs.php";
      script.async = true;
      script.onload = () => {
        triggerRevive();
      };
      document.body.appendChild(script);
    } else {
      triggerRevive();
    }
  }, [isMobile]);

  return (
    <div style={{ backgroundColor: "black" }}>
      <div style={{ width: "100%", marginBottom: "48px" }}>
        <Header />
        <IsNoVideo>
          <div style={{ color: "white", margin: "4px auto", textAlign: "center" }}>
            <h2>
              Dang it, something went wrong. Please go to{" "}
              <Link to="/home">VIBE-STREAM.TV/home</Link>
            </h2>
          </div>
        </IsNoVideo>
      </div>

      {/* Revive Adserver Display Banner */}
      <div style={{ textAlign: "center", margin: "20px auto" }}>
        {isMobile ? (
          <ins data-revive-zoneid="30345" data-revive-id="727bec5e09208690b050ccfc6a45d384"></ins>
        ) : (
          <ins data-revive-zoneid="30247" data-revive-id="727bec5e09208690b050ccfc6a45d384"></ins>
        )}
      </div>

      <div
        style={{
          color: "white",
          width: "85%",
          maxWidth: "1400px",
          margin: "0 auto",
          padding: "0 0 8px 0",
        }}
      >

        <div style={{
          display: "inline-block",
          width: "70%",
          color: "white",
        }}>
          <h4 className="font-semibold">{curTitle}</h4>
          <h6>{curArtist}</h6>
        </div>
        <div
          style={{
            display: "inline-block",
            float: "right"
          }}
        >
          {isShare && window.screen.width > 800 ? (
            <img
              style={{ cursor: "pointer", }}
              src={dldIcn}
              alt='download'
              onClick={() => {
                downloadOriginal()
              }}
            />
          ) : (
            <></>
          )}
        </div>
        {/* <div style={{ display: "inline-block", float: "right" }}>
          <CopyEmbedVideo video={video} />
        </div> */}
      </div>
      <div className="video-con">
        <div
          className="video-player-wrapper"
          onMouseEnter={handleVideoMouseEnter}
          onMouseLeave={handleVideoMouseLeave}
          onMouseMove={handleMouseMove}
          onClick={handleVideoTap}
        >
          <video
            ref={videoRef}
            className="video-js vjs-16-9 vjs-default-skin vjs-big-play-centered single-video"
            poster={singleThnail}
          />

          {/* Video Overlay Menu (Center Controls + Side Menu) */}
          <VideoOverlayMenu
            playerRef={player}
            videoId={video?.id}
            videoUUID={video?.video_id}
            videoTitle={curTitle}
            videoArtist={curArtist}
            isLiked={isBookmarked}
            isPlaying={isVideoPlaying}
            isFullscreen={isFullscreen}
            isAdPlaying={isAdPlaying}
            onPlayPause={handlePausePlay}
            onFullscreen={handleFullscreen}
            onLike={(videoId) => {
              // Handle bookmark change if needed
            }}
            showPlayPause={true}
            showFullscreen={true}
            showSkip={false}
            showBookmark={true}
            showCopyLink={true}
            showThumbsdown={false}
            visible={showSkipOverlay || !isVideoPlaying}
            isMobile={window.screen.width <= 800}
          />

          {/* Progress Bar */}
          <div className="video-progress-bar">
            <div
              className="video-progress-fill"
              style={{ width: `${videoProgress}%` }}
            />
          </div>
        </div>
      </div>

      {linkOut ? (
        <><div
          style={{
            color: "#ff71ee",
            width: "80%",
            margin: "0 auto",
            marginTop: "25px",
            textAlign: "center"
          }}
        >
          <a href={linkOut}>

            <img
              className='alb-img'
              src={video.album_artwork}
              alt="album artwork" />
          </a>
        </div>
        </>
      ) : albumArt ? (
        <><div
          style={{
            color: "#ff71ee",
            width: "80%",
            margin: "0 auto",
            marginTop: "25px",
            textAlign: "center"
          }}
        >
          <img
            className='alb-img'
            src={video.album_artwork}
            alt="album artwork" />
        </div>
        </>
      ) : (
        <></>
      )}

      <div className="img-con">
        <Link to="/allplaylists">
          <img
            className="imgBtn"
            style={{ marginTop: "45px" }}
            src={vwAllIcn}
            width="20%"
            alt="view all"
          />
        </Link>
      </div>
      {/* <div className="img-con">
        <a href="https://app.gogopix.co/gogopixtv">
          <img
            className="imgBtn"
            style={{ marginTop: "45px" }}
            src={stoIcns}
            width="30%"
            alt="get the app logo"
          />
        </a>
      </div> */}
      <Footer />
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader>Video URL copied</ModalHeader>
        <ModalBody>
          The video url titled "{copiedTitle}" has been copied to the clipboard.
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Ok
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default SingleVideo;
